export const therapyType = {
  0: "Unassigned",

  1: "Acute",

  2: "Chronic",
};
